import { useLayoutEffect, useState } from 'react';

// Uniformly scales a fixed-size "design" (innerRef) so it fits inside outerRef.
export function useFitScale(outerRef, innerRef, { maxScale = 1.6, compactBelow = 640, fill = 0.9 } = {}) {
  const [fit, setFit] = useState({ scale: 1, compact: false, ready: false });
  useLayoutEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) return undefined;
    const measure = () => {
      const w = outer.clientWidth;
      const h = outer.clientHeight;
      const scale = Math.min((w * fill) / inner.offsetWidth, (h * fill) / inner.offsetHeight, maxScale);
      setFit({ scale, compact: w < compactBelow, wide: w / h > 2.2 && h < 450, ready: true });
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(outer);
    ro.observe(inner);
    return () => ro.disconnect();
  }, [outerRef, innerRef, maxScale, compactBelow, fill]);
  return fit;
}
